import { render, staticRenderFns } from "./TBA_claim.vue?vue&type=template&id=73687bb4&"
import script from "./TBA_claim.vue?vue&type=script&lang=js&"
export * from "./TBA_claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports